import { OccFirstVisitLogParams } from '@analytics/const';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AnalyticsActions } from '../store';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsFacade {
  constructor(private store: Store) {}

  firstVisitLog(params: OccFirstVisitLogParams): void {
    this.store.dispatch(new AnalyticsActions.FirstVisitLog(params));
  }
}
